'use strict';

var colors = {
	"Web Dev": "#d32f2f",
	"CAD": "#c2185b",
	"Back End": "#7b1fa2",
	"Dart": "#512da8",
	"Low Level": "#303f9f",
	"Web Dev": "#1976d2",
	"Servers and Networks": "#0288d1",
	"Mobile Dev": "#ad1457",
	"Esoteric": "#1565c0",
	"Robotics": "#880e4f",
	"Hardware Design": "#4a148c",
}

document.querySelectorAll(".post-card-tags").forEach(function(e) {
	var color = colors[e.innerText]
	if (color) {
		e.style["background-color"] = color
	}
})

var e = document.querySelector(".site-title")
if (e) {
	var color = colors[e.innerText]
	if (color) {
		document.querySelector(".site-header").style["background-color"] = color
	}
}